/**
 * @generated SignedSource<<a692f9b5d525aeddaa32b751148151b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UploadContext = "AVATARS" | "FILES" | "%future added value";
export type useUppyAwsS3UploadParametersMutation$variables = {
  fileName: string;
  fileSize: Int;
  fileType: string;
  uploadContext: UploadContext;
};
export type useUppyAwsS3UploadParametersMutation$data = {
  readonly presignUpload: {
    readonly uploadSignature: {
      readonly signature: {
        readonly fields: UnknownJSON | null;
        readonly headers: UnknownJSON;
        readonly method: string;
        readonly url: string;
      };
      readonly uploadToken: string;
    };
  } | null;
};
export type useUppyAwsS3UploadParametersMutation = {
  response: useUppyAwsS3UploadParametersMutation$data;
  variables: useUppyAwsS3UploadParametersMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileName"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileSize"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fileType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uploadContext"
},
v4 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "fileName",
            "variableName": "fileName"
          },
          {
            "kind": "Variable",
            "name": "fileSize",
            "variableName": "fileSize"
          },
          {
            "kind": "Variable",
            "name": "fileType",
            "variableName": "fileType"
          },
          {
            "kind": "Variable",
            "name": "uploadContext",
            "variableName": "uploadContext"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "UploadsPresignMutationPayload",
    "kind": "LinkedField",
    "name": "presignUpload",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UploadSignature",
        "kind": "LinkedField",
        "name": "uploadSignature",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "uploadToken",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "S3Signature",
            "kind": "LinkedField",
            "name": "signature",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "method",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "fields",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "headers",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useUppyAwsS3UploadParametersMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "useUppyAwsS3UploadParametersMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "5b3da0e4fad02d70293584151d27f7c3",
    "id": null,
    "metadata": {},
    "name": "useUppyAwsS3UploadParametersMutation",
    "operationKind": "mutation",
    "text": "mutation useUppyAwsS3UploadParametersMutation(\n  $uploadContext: UploadContext!\n  $fileName: String!\n  $fileType: String!\n  $fileSize: BigInt!\n) {\n  presignUpload(input: {uploadContext: $uploadContext, fileName: $fileName, fileType: $fileType, fileSize: $fileSize}) {\n    uploadSignature {\n      uploadToken\n      signature {\n        method\n        url\n        fields\n        headers\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "7d2a9ca0a3a61d3ca0af9054a01e5f86";

export default node;
